<div class="dialog-content-max">
    <form [formGroup]="requestform">
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="entityname" class="required-label">Entity Name<span class="maxchars">(Max 100
                        chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="entityname" name="entityname" formControlName="entityname"
                    placeholder="Enter Entity Name">
                <span class="errormessage"
                    *ngIf="requestform.get('entityname').invalid && (requestform.get('entityname').touched || requestform.get('entityname').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entityname') }}
                </span>

            </div>
            <div class="field col-6">
                <label for="entityinitial" class="required-label">Entity Initial<span class="maxchars">(Max 100
                        chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="entityinitial" formControlName="entityinitial"
                    name="entityinitial" placeholder="Enter Entity Initial">
                <span class="errormessage"
                    *ngIf="requestform.get('entityinitial').invalid && (requestform.get('entityinitial').touched || requestform.get('entityinitial').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entityinitial') }}
                </span>

            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col-6">
                <label for="fromdate" class="bold-red-text" style="margin-bottom: 0.5rem; display: block;">From Date</label>
                <p-calendar class="custom-calendar" (onSelect)="onDateChange($event)" [showIcon]="true"
                    pTooltip="Select From Date" [(ngModel)]="filterinput.fromdate" placeholder="Choose Date"
                    dateFormat="dd-M-yy" [readonlyInput]="true" styleClass="pcalendar-readonly" [showOtherMonths]="true"
                    [selectOtherMonths]="true" (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)"
                    inputId="fromdate" [showButtonBar]="true" appendTo="body">
                </p-calendar>
                 <span class="errormessage"
                        *ngIf="requestform.get('fromdate').invalid && (requestform.get('fromdate').touched || requestform.get('fromdate').dirty)">
                    {{ getErrorMessage(requestform, validation_message, 'fromdate') }}
                </span>
            </div>
        </div>

    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="closemodal(requestform,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="add()"></p-button>
    </div>
</div>